import React from 'react';
import Breadcrumbs from '../components/Breadcrumbs';
import { gql } from '../graphql/generated';
import type { DocumentType } from '../graphql/generated';
import topicPath from '../utils/url/topicPath';
import * as styles from './ContentMapColumnBreadcrumbs.module.scss';
import ContentMapColumnHeader from './ContentMapColumnHeader';

const TOPIC_FRAGMENT = gql(`
  fragment ContentMapColumnBreadcrumbs_breadcrumbs on TopicFields {
    id
    ...ContentMapColumnHeader_topic
    ...topicPath_topic
  }
`);

interface ContentMapColumnBreadcrumbsProps {
  movedIn: boolean;
  link: boolean;
  breadcrumbs: DocumentType<typeof TOPIC_FRAGMENT>[];
}

const ContentMapColumnBreadcrumbs = ({
  movedIn,
  link,
  breadcrumbs,
}: ContentMapColumnBreadcrumbsProps) => {
  if (breadcrumbs.length === 1 && breadcrumbs[0]) {
    return (
      <div className={styles.container}>
        <ContentMapColumnHeader
          movedIn={movedIn}
          link={link}
          topic={breadcrumbs[0]}
        />
      </div>
    );
  }

  const items = breadcrumbs.map((topic, index) => {
    return {
      name: index === 0 ? <div>{topic.name}</div> : topic.name,
      to: link ? topicPath(topic) : undefined,
    };
  });

  return (
    <div className={styles.container}>
      <Breadcrumbs truncate size="small" items={items} />
    </div>
  );
};

export default ContentMapColumnBreadcrumbs;
